import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import {
    Tab,
    Nav,
    Dropdown,
    Form,
    Col,
    Row,
    FormGroup,
    Card,
} from "react-bootstrap";
import { memberdetail } from "../../../services/admin";
import moment from "moment/moment";
import ImageUrl from "../../../ImageUrl";
import KycVerification from "./kycverification";
import { getrestrictions } from "../../../services/setting";
import defaultPhoto from "../../../assets/images/women.png";

// DOB is stored as free text (e.g. "23/06/1998"), which moment() can't parse
// without being told the format — otherwise it shows "Invalid date". Try the
// common formats (strict) and fall back to the raw value if none match.
const fmtDob = (d) => {
    if (!d) return "";
    const m = moment(d, ["DD/MM/YYYY", "DD-MM-YYYY", "DD.MM.YYYY", "YYYY-MM-DD", moment.ISO_8601], true);
    return m.isValid() ? m.format("DD-MM-YYYY") : d;
};

export default function Memberprofile() {
    const { id, gid } = useParams();
    const [activeTab, setActiveTab] = useState("tab1");

    // The KYC tab only earns its place when at least one of the Aadhaar / PAN /
    // bank channels is switched on in Settings; with all three off the tab has
    // nothing to show. Starts hidden so it never flashes in before the answer.
    const [kycEnabled, setKycEnabled] = useState(false);
    const [grpenabled, setGrpEnabled] = useState(false);
    const [indienabled, setIndiEnabled] = useState(false);

    useEffect(() => {
        getrestrictions().then((res) => {
            const details = res?.data?.details;

            setGrpEnabled(details?.allow_group_loans ?? true);
            setIndiEnabled(details?.allow_individual_loans ?? true);
            const channels = res?.data?.allowed_kyc_channels;
            setKycEnabled(channels ? Object.values(channels).some(Boolean) : true);
        });
    }, []);
    const [uname, setUName] = useState("");
    const [pass, setPass] = useState("");
    const [adate, setADate] = useState("");
    const [aloan, setALoan] = useState("");
    const [mname, setMName] = useState("");
    const [mdob, setMDob] = useState("");
    const [mage, setMAge] = useState("");
    const [sgender, setSGender] = useState("");
    const [marital, setMarital] = useState("");
    const [hname, setHName] = useState("");
    const [hdob, setHDob] = useState("");
    const [hage, setHAge] = useState("");
    const [phone, setPhone] = useState("");
    const [altnum, setAltnum] = useState("");
    const [aadno, setAadno] = useState("");
    const [mplace, setMPlace] = useState("");
    const [purl, setPUrl] = useState("");

    const [srel, setSRel] = useState("");
    const [scaste, setSCaste] = useState("");
    const [subcas, setSubCas] = useState("");

    const [mdetail, setMDetail] = useState("");
    const [hdetail, setHDetail] = useState("");
    const [paddr, setPAddr] = useState("");
    const [taddr, setTAddr] = useState("");
    const [occu, setOccu] = useState("");
    const [idaily, setIDaily] = useState("");
    const [imonth, setIMonth] = useState("");
    const [iwdays, setIWDays] = useState("");
    const [anninc, setAnnInc] = useState("");

    const [lincome, setLIncome] = useState("");
    const [pincome, setPIncome] = useState("");
    const [oincome, setOIncome] = useState("");
    const [ototal, setOTotal] = useState("");

    const [ohouse, setOHouse] = useState("");
    const [rhouse, setRHouse] = useState("");
    const [lhouse, setLHouse] = useState("");
    const [oassets, setOAssets] = useState("");

    const [mgroup, setMGroup] = useState("");
    const [efee, setEFee] = useState("");
    const [mcenter, setMCenter] = useState("");

    const [schlist, setSchList] = useState([]);
    const [buttonvis, setButtonVis] = useState(0);


    const [urllink, setUrllink] = useState("");

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    const location = useLocation();
    useEffect(() => {

        const path = location.pathname.split("/")[2];
        setUrllink(path);

        memberdetail(id).then((res) => {
            if (res.status === true) {
                // A member can hold BOTH group and individual loans, so show a
                // tab for each. Tag every loan with its type and a unique tab key
                // (group/individual ids can overlap), and total across both.
                const groupLoans = (res.data.loan_details || []).map((l) => ({
                    ...l, loan_type: "group", tab_key: `group-${l.loan_entry_id}`,
                }));
                const indiLoans = (res.data.individual_loan_details || []).map((l) => ({
                    ...l, loan_type: "individual", tab_key: `individual-${l.loan_entry_id}`,
                }));
                const combined = [...groupLoans, ...indiLoans];
                setSchList(combined);
                if (combined.length > 0) {
                    const totalAmount = combined.reduce((sum, scheme) => sum + (parseInt(scheme.total_amount) || 0), 0);
                    setALoan(totalAmount);
                }

                if (res.data.details !== null) {
                    setUName(res.data.details.username ?? "");
                    setPass(res.data.details.password ?? "");
                    setMName(res.data.details.member_name);
                    setMDob(res.data.details.member_dob);
                    setMAge(res.data.details.member_age);
                    setSGender(res.data.details.gender);
                    setMarital(res.data.details.marital_status);
                    setHName(res.data.details.husband_name);
                    setHDob(res.data.details.husband_dob);
                    setHAge(res.data.details.husband_age);
                    setPhone(res.data.details.phone_no);
                    setAltnum(res.data.details.alternate_no);
                    setAadno(res.data.details.aadhar_no);
                    setMPlace(res.data.details.native_place);

                    setSRel(res.data.details.religion_name);
                    setSCaste(res.data.details.caste_name);
                    setSubCas(res.data.details.subcaste_name);
                    setMDetail(res.data.details.member_detail);
                    setHDetail(res.data.details.husband_detail);
                    setPAddr(res.data.details.permanent_address);
                    setTAddr(res.data.details.temporary_address);
                    setOccu(res.data.details.occupation);
                    setIDaily(res.data.details.daily_income);
                    setIMonth(res.data.details.monthly_income);
                    setIWDays(res.data.details.working_days);
                    setAnnInc(res.data.details.annual_income);
                    setLIncome(res.data.details.nancei_income);
                    setPIncome(res.data.details.puncei_income);
                    setOIncome(res.data.details.other_income);
                    setOTotal(res.data.details.overall_total);
                    setOHouse(res.data.details.own_house);
                    setRHouse(res.data.details.rent_house);
                    setLHouse(res.data.details.lease_house);
                    setOAssets(res.data.details.other_assets);
                    setMGroup(res.data.details.group_name);
                    setEFee(res.data.details.entry_fee);
                    setMCenter(res.data.details.group_center);
                    setButtonVis(res.data.details.active);
                    if (res.data.photo !== null) {
                        setPUrl(ImageUrl + res.data.path + res.data.details.photo);
                    }
                    setADate(moment(res.data.details.created_at).format("DD-MM-YYYY"));
                }
            }
        })
    }, [location.pathname]);


    function errorphoto(ev) {
        ev.target.src = defaultPhoto;
        ev.target.onerror = null;
    }

    // The on-screen profile is tab/card based and doesn't paginate well, so the
    // print job renders a purpose-built A4 sheet into an offscreen iframe rather
    // than trying to restyle this page with @media print rules.
    function printprofile() {
        const esc = (v) =>
            (v === null || v === undefined ? "" : String(v)).replace(
                /[&<>"']/g,
                (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c])
            );

        const fields = (list) =>
            list
                .map(
                    ([label, value]) =>
                        `<div class="f"><span class="l">${esc(label)}</span><span class="v">${esc(value) || "-"}</span></div>`
                )
                .join("");

        const block = (title, list) =>
            `<section class="block"><h2>${esc(title)}</h2><div class="grid">${fields(list)}</div></section>`;

        // Webpack gives asset paths relative to the page; the iframe starts on
        // about:blank, so absolutise them before they go into its markup.
        const fallback = new URL(defaultPhoto, window.location.href).href;
        const photo = purl || fallback;

        const html = `<!DOCTYPE html><html><head><meta charset="utf-8" />
<title>Member Profile - ${esc(mname)}</title>
<style>
  /* A zero page margin is what suppresses the browser's own header/footer
     (page title, date, URL); the real margin comes from the body padding. */
  @page { size: A4; margin: 0; }
  * { box-sizing: border-box; }
  body { font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: #222; margin: 0; padding: 12mm; }
  .head { display: flex; align-items: center; gap: 16px; border-bottom: 2px solid #333; padding-bottom: 10px; margin-bottom: 12px; }
  .head img { width: 90px; height: 110px; object-fit: cover; border: 1px solid #999; }
  .head .t { flex: 1; }
  .head h1 { font-size: 18px; margin: 0 0 4px; }
  .head .name { font-size: 15px; font-weight: bold; margin: 0 0 2px; }
  .head .meta { color: #555; }
  .block { margin-bottom: 12px; page-break-inside: avoid; }
  .block h2 { font-size: 12px; text-transform: uppercase; letter-spacing: .5px; background: #f0f0f0; border-left: 3px solid #333; padding: 4px 6px; margin: 0 0 6px; }
  .grid { display: grid; grid-template-columns: 1fr 1fr; gap: 0 18px; }
  .f { display: flex; padding: 3px 0; }
  .l { width: 45%; font-weight: bold; }
  .l:after { content: ":"; float: right; padding-right: 6px; }
  .v { width: 55%; word-break: break-word; }
  table.loans { width: 100%; border-collapse: collapse; }
  table.loans th, table.loans td { border: 1px solid #bbb; padding: 4px 6px; text-align: left; }
  table.loans th { background: #f0f0f0; }
</style></head><body>
<div class="head">
  <img src="${esc(photo)}" alt="Member photo" onerror="this.onerror=null;this.src='${esc(fallback)}'" />
  <div class="t">
    <h1>Member Profile</h1>
    <p class="name">${esc(mname)}</p>
    <p class="meta">Group: ${esc(mgroup) || "-"} &nbsp;|&nbsp; Center: ${esc(mcenter) || "-"} &nbsp;|&nbsp; Added on: ${esc(adate) || "-"}</p>
  </div>
</div>
${block("Member Detail", [
            ["Name", mname],
            ["DOB", fmtDob(mdob)],
            ["Age", mage],
            ["Gender", sgender],
            ["Marital Status", marital],
            ["Phone Number", phone],
            ["Alternate Number", altnum],
            ["Aadhar No", aadno],
            ["Native Place", mplace],
            ["Religion", srel],
            ["Caste", scaste],
            ["Sub Caste", subcas],
            ["Member Detail", mdetail],
            ["Entry Fee", efee],
            ["Permanent Address", paddr],
            ["Temporary Address", taddr],
        ])}
${block("Partner / Parents Detail", [
            ["Name", hname],
            ["DOB", fmtDob(hdob)],
            ["Age", hage],
            ["Detail", hdetail],
        ])}
${block("Income Details", [
            ["Occupation", occu],
            ["Working Days", iwdays],
            ["Daily Income", idaily ? `Rs. ${idaily}` : ""],
            ["Monthly Income", imonth ? `Rs. ${imonth}` : ""],
            ["Annual Income", anninc ? `Rs. ${anninc}` : ""],
        ])}
${block("Land Details", [
            ["Nansei Income", lincome ? `Rs. ${lincome}` : ""],
            ["Punsei Income", pincome ? `Rs. ${pincome}` : ""],
            ["Other Income", oincome ? `Rs. ${oincome}` : ""],
            ["Over All Total", ototal ? `Rs. ${ototal}` : ""],
        ])}
${block("Asset Details", [
            ["Own House", ohouse],
            ["Rent House", rhouse],
            ["Lease House", lhouse],
            ["Other", oassets],
        ])}
${schlist.length > 0
                ? `<section class="block"><h2>Loan Summary</h2>
<table class="loans"><thead><tr><th>#</th><th>Type</th><th>Scheme</th><th>Interest</th><th>Dues</th><th>Total</th><th>Status</th></tr></thead>
<tbody>${schlist
                    .map(
                        (s, i) =>
                            `<tr><td>${i + 1}</td><td>${s.loan_type === "individual" ? "Individual" : "Group"}</td><td>${esc(
                                s.scheme_name
                            )}</td><td>Rs. ${esc(s.interest)}</td><td>${esc(s.no_of_dues)}</td><td>Rs. ${esc(
                                s.total_amount
                            )}</td><td>${s.loan_status == 2 ? "Rejected" : s.loan_status == 3 ? "Completed" : "Ongoing"}</td></tr>`
                    )
                    .join("")}</tbody></table></section>`
                : ""
            }
</body></html>`;

        const frame = document.createElement("iframe");
        frame.setAttribute("aria-hidden", "true");
        frame.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0;";
        document.body.appendChild(frame);

        const doc = frame.contentWindow.document;
        doc.open();
        doc.write(html);
        doc.close();

        const cleanup = () => {
            if (frame.parentNode) frame.parentNode.removeChild(frame);
        };

        // Printing before the photo has decoded leaves a blank box, so wait it out.
        const images = Array.from(doc.images);
        Promise.all(
            images.map((img) =>
                img.complete
                    ? Promise.resolve()
                    : new Promise((resolve) => {
                        img.onload = resolve;
                        img.onerror = resolve;
                    })
            )
        ).then(() => {
            frame.contentWindow.focus();
            frame.contentWindow.print();
            setTimeout(cleanup, 1000);
        });
    }
    const navigate = useNavigate();
    function backlist() {
        if (urllink === "groupmemberprofile") {
            navigate(`/group/groupdetail/${gid}`);
        } else {
            if (buttonvis == 1) {
                navigate("/member/allmembers");
            } else {
                navigate("/member/deletedmember");
            }
        }
    }

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">Member Profile</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Member</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Member Profile
                    </li>
                </ol>
            </div>
            <div className="container-fluid">
                <div className="inner-body">

                    <div className="row row-sm">
                        <div className="col-lg-12 mb-2">
                            <div className="text-end">
                                {buttonvis == 1 && indienabled &&
                                    <Link to={`/individualloan/add/${id}`} className="btn btn-primary me-2 mb-2">
                                        <i className="fa fa-plus"></i> Create Individual Loan
                                    </Link>

                                }
                                {buttonvis == 1 && grpenabled &&
                                    <Link to={`/loan/addloan/${id}`} className="btn btn-success me-2 mb-2">
                                        <i className="fa fa-plus"></i> Create Group Loan
                                    </Link>
                                }

                                <a className="btn btn-info me-2 mb-2" onClick={printprofile}>
                                    <i className="fa fa-print"></i> Print
                                </a>

                                <a className="btn btn-secondary mb-2" onClick={backlist}>
                                    Back
                                </a>
                            </div>
                        </div>
                        {/* Left Profile Card */}
                        <div className="col-xl-3 col-lg-12 col-md-12">
                            <div className="card custom-card">
                                <div className="card-body text-center item-user">
                                    <div className="profile-pic">
                                        <div className="profile-pic-img">
                                            <img
                                                alt="avatar"
                                                src={purl}
                                                onError={(e) => errorphoto(e)}
                                            />
                                        </div>
                                        <a href="#" className="text-dark">
                                            <h5 className="mt-3 mb-0 font-weight-semibold">
                                                {mname}
                                            </h5>
                                        </a>
                                    </div>
                                </div>
                                {/* Profile Info */}
                                <ul className="item1-links nav nav-tabs mb-0">
                                    <li className="nav-item">
                                        <a className="float-end nav-links text-danger">{adate}</a>
                                        <a className="nav-links nav-link text-danger">
                                            <i className="fas fa-calendar-plus icon1"></i> Added on
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="float-end nav-links">{sgender}</a>
                                        <a className="nav-links nav-link">
                                            <i className="fas fa-user icon1"></i> Gender
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="float-end nav-links">{marital}</a>
                                        <a className="nav-links nav-link">
                                            <i className="fas fa-ring icon1"></i> Marital Status
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="float-end nav-links">{phone}</a>
                                        <a className="nav-links nav-link">
                                            <i className="fa fa-phone-square"></i> Phone No
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="float-end nav-links">{altnum}</a>
                                        <a className="nav-links nav-link">
                                            <i className="fa fa-phone-square"></i> Alternate No
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="float-end nav-links">{aloan}</a>
                                        <a className="nav-links nav-link">
                                            <i className="fa fa-credit-card"></i> Allocated Loan
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="float-end nav-links">{schlist.length}</a>
                                        <a className="nav-links nav-link">
                                            <i className="fa fa-address-book"></i> Loan
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="float-end nav-links">{mcenter}</a>
                                        <a className="nav-links nav-link">
                                            <i className="fa fa-map-marker"></i> Center
                                        </a>
                                    </li>
                                    {uname !== "" && (
                                        <>
                                            <li className="nav-item">
                                                <a className="float-end nav-links">{uname}</a>
                                                <a className="nav-links nav-link">
                                                    <i className="fa fa-user-circle"></i> Username
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="float-end nav-links">{pass}</a>
                                                <a className="nav-links nav-link">
                                                    <i className="fa fa-key"></i> Password
                                                </a>
                                            </li>
                                        </>
                                    )}
                                </ul>
                            </div>
                        </div>

                        {/* Right Tabs Section */}
                        <div className="col-xl-9 col-lg-12 col-md-12">
                            <div className="card custom-card mg-b-20" id="tabs-style2">
                                <div className="card-body">
                                    <div className="tabs-container">
                                        {/* Tab Headers */}
                                        <div className="tabs-menu">
                                            <button
                                                className={`tab-button ${activeTab === "tab1" ? "active" : ""
                                                    }`}
                                                onClick={() => handleTabClick("tab1")}
                                            >
                                                <i className="mdi mdi-account-box-outline"></i> Profile
                                            </button>

                                            {kycEnabled && (
                                                <button
                                                    className={`tab-button ${activeTab === "kyc" ? "active" : ""
                                                        }`}
                                                    onClick={() => handleTabClick("kyc")}
                                                >
                                                    <i className="mdi mdi-shield-check-outline"></i> KYC
                                                </button>
                                            )}

                                            {schlist.map((scheme, index) => {
                                                // Number group and individual loans independently and
                                                // label/icon them so the two kinds are easy to tell apart.
                                                const isIndi = scheme.loan_type === "individual";
                                                const typeIndex = schlist.slice(0, index).filter((s) => s.loan_type === scheme.loan_type).length + 1;
                                                return (
                                                    <button
                                                        key={scheme.tab_key}
                                                        className={`tab-button ${activeTab === scheme.tab_key ? "active" : ""}`}
                                                        onClick={() => handleTabClick(scheme.tab_key)}
                                                    >
                                                        <i className={`fa ${isIndi ? "fa-user-circle" : "fa-users"} headericons`}></i>
                                                        {isIndi ? "Individual" : "Group"} Loan {typeIndex} - {scheme.scheme_name}
                                                    </button>
                                                );
                                            })}

                                        </div>

                                        {/* Tab Content */}
                                        <div className="tab-content">
                                            {kycEnabled && activeTab === "kyc" && (
                                                <KycVerification memberId={id} status={buttonvis} />
                                            )}
                                            {activeTab === "tab1" && (
                                                <div className="row">
                                                    <div className="card custom-card mg-t-15 col-xl-12 col-lg-12 col-md-12">
                                                        <Card className="custom-card body-bg">
                                                            <Card.Header>
                                                                <div className="d-md-flex ms-auto">
                                                                    <label className="main-content-label my-auto pt-2"> Member Detail</label>
                                                                </div>
                                                            </Card.Header>
                                                            <div className="row">
                                                                <div className="col-xl-6 col-lg-6 col-md-12">
                                                                    <Card.Body>
                                                                        <Form className="form-horizontal">
                                                                            <FormGroup className="form-group">
                                                                                <Row className="row-sm">
                                                                                    <Col md={5} sm={5}>
                                                                                        <h3 className="studentdetail-a">
                                                                                            Name <span className="pull-end">:</span>
                                                                                        </h3>
                                                                                    </Col>
                                                                                    <Col md={7} sm={7}>
                                                                                        <h3 className="student-detail-b">
                                                                                            {mname}
                                                                                        </h3>
                                                                                    </Col>
                                                                                </Row>
                                                                            </FormGroup>
                                                                            <FormGroup className="form-group">
                                                                                <Row className="row-sm">
                                                                                    <Col md={5} sm={5}>
                                                                                        <h3 className="studentdetail-a">
                                                                                            DOB <span className="pull-end">:</span>
                                                                                        </h3>
                                                                                    </Col>
                                                                                    <Col md={7} sm={7}>
                                                                                        <h3 className="student-detail-b">
                                                                                            {fmtDob(mdob)}
                                                                                        </h3>
                                                                                    </Col>
                                                                                </Row>
                                                                            </FormGroup>
                                                                            <FormGroup className="form-group">
                                                                                <Row className="row-sm">
                                                                                    <Col md={5} sm={5}>
                                                                                        <h3 className="studentdetail-a">
                                                                                            Age{" "}
                                                                                            <span className="pull-end">:</span>
                                                                                        </h3>
                                                                                    </Col>
                                                                                    <Col md={7} sm={7}>
                                                                                        <h3 className="student-detail-b">
                                                                                            {mage}
                                                                                        </h3>
                                                                                    </Col>
                                                                                </Row>
                                                                            </FormGroup>
                                                                            <FormGroup className="form-group">
                                                                                <Row className="row-sm">
                                                                                    <Col md={5} sm={5}>
                                                                                        <h3 className="studentdetail-a">
                                                                                            Phone Number {" "}
                                                                                            <span className="pull-end">:</span>
                                                                                        </h3>
                                                                                    </Col>
                                                                                    <Col md={7} sm={7}>
                                                                                        <h3 className="student-detail-b">
                                                                                            {phone}
                                                                                        </h3>
                                                                                    </Col>
                                                                                </Row>
                                                                            </FormGroup>
                                                                            <FormGroup className="form-group">
                                                                                <Row className="row-sm">
                                                                                    <Col md={5} sm={5}>
                                                                                        <h3 className="studentdetail-a">
                                                                                            Alternate Number {" "}
                                                                                            <span className="pull-end">:</span>
                                                                                        </h3>
                                                                                    </Col>
                                                                                    <Col md={7} sm={7}>
                                                                                        <h3 className="student-detail-b">
                                                                                            {altnum}
                                                                                        </h3>
                                                                                    </Col>
                                                                                </Row>
                                                                            </FormGroup>
                                                                            <FormGroup className="form-group">
                                                                                <Row className="row-sm">
                                                                                    <Col md={5} sm={5}>
                                                                                        <h3 className="studentdetail-a">
                                                                                            Aadhar No{" "}
                                                                                            <span className="pull-end">:</span>
                                                                                        </h3>
                                                                                    </Col>
                                                                                    <Col md={7} sm={7}>
                                                                                        <h3 className="student-detail-b">
                                                                                            {aadno}
                                                                                        </h3>
                                                                                    </Col>
                                                                                </Row>
                                                                            </FormGroup>
                                                                            <FormGroup className="form-group">
                                                                                <Row className="row-sm">
                                                                                    <Col md={5} sm={5}>
                                                                                        <h3 className="studentdetail-a">
                                                                                            Native Pllace{" "}
                                                                                            <span className="pull-end">:</span>
                                                                                        </h3>
                                                                                    </Col>
                                                                                    <Col md={7} sm={7}>
                                                                                        <h3 className="student-detail-b">
                                                                                            {mplace}
                                                                                        </h3>
                                                                                    </Col>
                                                                                </Row>
                                                                            </FormGroup>
                                                                            <FormGroup className="form-group">
                                                                                <Row className="row-sm">
                                                                                    <Col md={5} sm={5}>
                                                                                        <h3 className="studentdetail-a">
                                                                                            Member Detail{" "}
                                                                                            <span className="pull-end">:</span>
                                                                                        </h3>
                                                                                    </Col>
                                                                                    <Col md={7} sm={7}>
                                                                                        <h3 className="student-detail-b">
                                                                                            {mdetail}
                                                                                        </h3>
                                                                                    </Col>
                                                                                </Row>
                                                                            </FormGroup>
                                                                            <FormGroup className="form-group">
                                                                                <Row className="row-sm">
                                                                                    <Col md={5} sm={5}>
                                                                                        <h3 className="studentdetail-a">
                                                                                            Permanent Address
                                                                                            <span className="pull-end">:</span>
                                                                                        </h3>
                                                                                    </Col>
                                                                                    <Col md={7} sm={7}>
                                                                                        <h3 className="student-detail-b">
                                                                                            {paddr}
                                                                                        </h3>
                                                                                    </Col>
                                                                                </Row>
                                                                            </FormGroup>

                                                                        </Form>
                                                                    </Card.Body>
                                                                </div>
                                                                <div className="col-xl-6 col-lg-6 col-md-12">
                                                                    <Card.Body>
                                                                        <Form className="form-horizontal">
                                                                            <FormGroup className="form-group">
                                                                                <Row className="row-sm">
                                                                                    <Col md={5} sm={5}>
                                                                                        <h3 className="studentdetail-a">
                                                                                            Partner / Parents Name <span className="pull-end">:</span>
                                                                                        </h3>
                                                                                    </Col>
                                                                                    <Col md={7} sm={7}>
                                                                                        <h3 className="student-detail-b">
                                                                                            {hname}
                                                                                        </h3>
                                                                                    </Col>
                                                                                </Row>
                                                                            </FormGroup>
                                                                            <FormGroup className="form-group">
                                                                                <Row className="row-sm">
                                                                                    <Col md={5} sm={5}>
                                                                                        <h3 className="studentdetail-a">
                                                                                            Partner / Parents DOB <span className="pull-end">:</span>
                                                                                        </h3>
                                                                                    </Col>
                                                                                    <Col md={7} sm={7}>
                                                                                        <h3 className="student-detail-b">
                                                                                            {fmtDob(hdob)}
                                                                                        </h3>
                                                                                    </Col>
                                                                                </Row>
                                                                            </FormGroup>
                                                                            <FormGroup className="form-group">
                                                                                <Row className="row-sm">
                                                                                    <Col md={5} sm={5}>
                                                                                        <h3 className="studentdetail-a">
                                                                                            Partner / Parents Age{" "}
                                                                                            <span className="pull-end">:</span>
                                                                                        </h3>
                                                                                    </Col>
                                                                                    <Col md={7} sm={7}>
                                                                                        <h3 className="student-detail-b">
                                                                                            {hage}
                                                                                        </h3>
                                                                                    </Col>
                                                                                </Row>
                                                                            </FormGroup>
                                                                            <FormGroup className="form-group">
                                                                                <Row className="row-sm">
                                                                                    <Col md={5} sm={5}>
                                                                                        <h3 className="studentdetail-a">
                                                                                            Religion{" "}
                                                                                            <span className="pull-end">:</span>
                                                                                        </h3>
                                                                                    </Col>
                                                                                    <Col md={7} sm={7}>
                                                                                        <h3 className="student-detail-b">
                                                                                            {srel}
                                                                                        </h3>
                                                                                    </Col>
                                                                                </Row>
                                                                            </FormGroup>
                                                                            <FormGroup className="form-group">
                                                                                <Row className="row-sm">
                                                                                    <Col md={5} sm={5}>
                                                                                        <h3 className="studentdetail-a">
                                                                                            Caste{" "}
                                                                                            <span className="pull-end">:</span>
                                                                                        </h3>
                                                                                    </Col>
                                                                                    <Col md={7} sm={7}>
                                                                                        <h3 className="student-detail-b">
                                                                                            {scaste}
                                                                                        </h3>
                                                                                    </Col>
                                                                                </Row>
                                                                            </FormGroup>
                                                                            <FormGroup className="form-group">
                                                                                <Row className="row-sm">
                                                                                    <Col md={5} sm={5}>
                                                                                        <h3 className="studentdetail-a">
                                                                                            Sub Caste{" "}
                                                                                            <span className="pull-end">:</span>
                                                                                        </h3>
                                                                                    </Col>
                                                                                    <Col md={7} sm={7}>
                                                                                        <h3 className="student-detail-b">
                                                                                            {subcas}
                                                                                        </h3>
                                                                                    </Col>
                                                                                </Row>
                                                                            </FormGroup>

                                                                            <FormGroup className="form-group mb-0">
                                                                                <Row className="row-sm">
                                                                                    <Col md={5} sm={5}>
                                                                                        <h3 className="studentdetail-a">
                                                                                            Partner / Parents Detail{" "}
                                                                                            <span className="pull-end">:</span>
                                                                                        </h3>
                                                                                    </Col>
                                                                                    <Col md={7} sm={7}>
                                                                                        <h3 className="student-detail-b">
                                                                                            {hdetail}
                                                                                        </h3>
                                                                                    </Col>
                                                                                </Row>
                                                                            </FormGroup>
                                                                            <FormGroup className="form-group">
                                                                                <Row className="row-sm">
                                                                                    <Col md={5} sm={5}>
                                                                                        <h3 className="studentdetail-a">
                                                                                            Temporary Address
                                                                                            <span className="pull-end">:</span>
                                                                                        </h3>
                                                                                    </Col>
                                                                                    <Col md={7} sm={7}>
                                                                                        <h3 className="student-detail-b">
                                                                                            {taddr}
                                                                                        </h3>
                                                                                    </Col>
                                                                                </Row>
                                                                            </FormGroup>
                                                                        </Form>
                                                                    </Card.Body>
                                                                </div>
                                                            </div>
                                                        </Card>
                                                        <Card className="custom-card body-bg">
                                                            <Card.Header className="">
                                                                <div className="d-md-flex ms-auto">
                                                                    <label className="main-content-label my-auto pt-2"> Income Details</label>
                                                                </div>
                                                            </Card.Header>
                                                            <div className="row">
                                                                <div className="col-xl-6 col-lg-6 col-md-12">
                                                                    <Card.Body>
                                                                        <Form className="form-horizontal">

                                                                            <FormGroup className="form-group">
                                                                                <Row className="row-sm">
                                                                                    <Col md={5} sm={5}>
                                                                                        <h3 className="studentdetail-a">
                                                                                            Occupation{" "}
                                                                                            <span className="pull-end">:</span>
                                                                                        </h3>
                                                                                    </Col>
                                                                                    <Col md={7} sm={7}>
                                                                                        <h3 className="student-detail-b">
                                                                                            {occu}
                                                                                        </h3>
                                                                                    </Col>
                                                                                </Row>
                                                                            </FormGroup>
                                                                            <FormGroup className="form-group">
                                                                                <Row className="row-sm">
                                                                                    <Col md={5} sm={5}>
                                                                                        <h3 className="studentdetail-a">
                                                                                            Daily Income <span className="pull-end">:</span>
                                                                                        </h3>
                                                                                    </Col>
                                                                                    <Col md={7} sm={7}>
                                                                                        <h3 className="student-detail-b">
                                                                                            ₹ {idaily}
                                                                                        </h3>
                                                                                    </Col>
                                                                                </Row>
                                                                            </FormGroup>
                                                                            <FormGroup className="form-group">
                                                                                <Row className="row-sm">
                                                                                    <Col md={5} sm={5}>
                                                                                        <h3 className="studentdetail-a">
                                                                                            Monthly Income <span className="pull-end">:</span>
                                                                                        </h3>
                                                                                    </Col>
                                                                                    <Col md={7} sm={7}>
                                                                                        <h3 className="student-detail-b">
                                                                                            ₹ {imonth}
                                                                                        </h3>
                                                                                    </Col>
                                                                                </Row>
                                                                            </FormGroup>

                                                                        </Form>
                                                                    </Card.Body>
                                                                </div>
                                                                <div className="col-xl-6 col-lg-6 col-md-12">
                                                                    <Card.Body>
                                                                        <Form className="form-horizontal">
                                                                            <FormGroup className="form-group">
                                                                                <Row className="row-sm">
                                                                                    <Col md={5} sm={5}>
                                                                                        <h3 className="studentdetail-a">
                                                                                            Working Days {" "}
                                                                                            <span className="pull-end">:</span>
                                                                                        </h3>
                                                                                    </Col>
                                                                                    <Col md={7} sm={7}>
                                                                                        <h3 className="student-detail-b">
                                                                                            {iwdays}
                                                                                        </h3>
                                                                                    </Col>
                                                                                </Row>
                                                                            </FormGroup>
                                                                            <FormGroup className="form-group">
                                                                                <Row className="row-sm">
                                                                                    <Col md={5} sm={5}>
                                                                                        <h3 className="studentdetail-a">
                                                                                            Annual Income{" "}
                                                                                            <span className="pull-end">:</span>
                                                                                        </h3>
                                                                                    </Col>
                                                                                    <Col md={7} sm={7}>
                                                                                        <h3 className="student-detail-b">
                                                                                            ₹ {anninc}
                                                                                        </h3>
                                                                                    </Col>
                                                                                </Row>
                                                                            </FormGroup>
                                                                        </Form>
                                                                    </Card.Body>
                                                                </div>
                                                            </div>
                                                        </Card>
                                                    </div>
                                                    <div className="card custom-card col-xl-6 col-lg-6 col-md-12">
                                                        <Card className="custom-card body-bg">
                                                            <Card.Header>
                                                                <div className="d-md-flex ms-auto">
                                                                    <label className="main-content-label my-auto pt-2">Land Details</label>
                                                                </div>
                                                            </Card.Header>
                                                            <Card.Body>
                                                                <Form className="form-horizontal">
                                                                    <FormGroup className="form-group">
                                                                        <Row className="row-sm">
                                                                            <Col md={5} sm={5}>
                                                                                <h3 className="studentdetail-a">
                                                                                    Nansei income <span className="pull-end">:</span>
                                                                                </h3>
                                                                            </Col>
                                                                            <Col md={7} sm={7}>
                                                                                <h3 className="student-detail-b">
                                                                                    ₹ {lincome}
                                                                                </h3>
                                                                            </Col>
                                                                        </Row>
                                                                    </FormGroup>
                                                                    <FormGroup className="form-group">
                                                                        <Row className="row-sm">
                                                                            <Col md={5} sm={5}>
                                                                                <h3 className="studentdetail-a">
                                                                                    Punsei Income <span className="pull-end">:</span>
                                                                                </h3>
                                                                            </Col>
                                                                            <Col md={7} sm={7}>
                                                                                <h3 className="student-detail-b">
                                                                                    ₹ {pincome}
                                                                                </h3>
                                                                            </Col>
                                                                        </Row>
                                                                    </FormGroup>
                                                                    <FormGroup className="form-group">
                                                                        <Row className="row-sm">
                                                                            <Col md={5} sm={5}>
                                                                                <h3 className="studentdetail-a">
                                                                                    Other Income <span className="pull-end">:</span>
                                                                                </h3>
                                                                            </Col>
                                                                            <Col md={7} sm={7}>
                                                                                <h3 className="student-detail-b">
                                                                                    ₹ {oincome}
                                                                                </h3>
                                                                            </Col>
                                                                        </Row>
                                                                    </FormGroup>
                                                                    <FormGroup className="form-group">
                                                                        <Row className="row-sm">
                                                                            <Col md={5} sm={5}>
                                                                                <h3 className="studentdetail-a">
                                                                                    Over All Total <span className="pull-end">:</span>
                                                                                </h3>
                                                                            </Col>
                                                                            <Col md={7} sm={7}>
                                                                                <h3 className="student-detail-b">
                                                                                    ₹ {ototal}
                                                                                </h3>
                                                                            </Col>
                                                                        </Row>
                                                                    </FormGroup>
                                                                </Form>
                                                            </Card.Body>
                                                        </Card>
                                                    </div>
                                                    <div className="card custom-card col-xl-6 col-lg-6 col-md-12">
                                                        <Card className="custom-card body-bg">
                                                            <Card.Header>
                                                                <div className="d-md-flex ms-auto">
                                                                    <label className="main-content-label my-auto pt-2"> Asset Details</label>
                                                                </div>
                                                            </Card.Header>
                                                            <Card.Body>
                                                                <Form className="form-horizontal">
                                                                    <FormGroup className="form-group">
                                                                        <Row className="row-sm">
                                                                            <Col md={5} sm={5}>
                                                                                <h3 className="studentdetail-a">
                                                                                    Own House <span className="pull-end">:</span>
                                                                                </h3>
                                                                            </Col>
                                                                            <Col md={7} sm={7}>
                                                                                <h3 className="student-detail-b">
                                                                                    {ohouse}
                                                                                </h3>
                                                                            </Col>
                                                                        </Row>
                                                                    </FormGroup>
                                                                    <FormGroup className="form-group">
                                                                        <Row className="row-sm">
                                                                            <Col md={5} sm={5}>
                                                                                <h3 className="studentdetail-a">
                                                                                    Rent House<span className="pull-end">:</span>
                                                                                </h3>
                                                                            </Col>
                                                                            <Col md={7} sm={7}>
                                                                                <h3 className="student-detail-b">
                                                                                    {rhouse}
                                                                                </h3>
                                                                            </Col>
                                                                        </Row>
                                                                    </FormGroup>
                                                                    <FormGroup className="form-group">
                                                                        <Row className="row-sm">
                                                                            <Col md={5} sm={5}>
                                                                                <h3 className="studentdetail-a">
                                                                                    Lease House{" "}
                                                                                    <span className="pull-end">:</span>
                                                                                </h3>
                                                                            </Col>
                                                                            <Col md={7} sm={7}>
                                                                                <h3 className="student-detail-b">
                                                                                    {lhouse}
                                                                                </h3>
                                                                            </Col>
                                                                        </Row>
                                                                    </FormGroup>
                                                                    <FormGroup className="form-group">
                                                                        <Row className="row-sm">
                                                                            <Col md={5} sm={5}>
                                                                                <h3 className="studentdetail-a">
                                                                                    Other{" "}
                                                                                    <span className="pull-end">:</span>
                                                                                </h3>
                                                                            </Col>
                                                                            <Col md={7} sm={7}>
                                                                                <h3 className="student-detail-b">
                                                                                    {oassets}
                                                                                </h3>
                                                                            </Col>
                                                                        </Row>
                                                                    </FormGroup>

                                                                </Form>
                                                            </Card.Body>
                                                        </Card>
                                                    </div>
                                                </div>

                                            )}

                                            {schlist.map((scheme, index) => {
                                                if (activeTab === scheme.tab_key) {
                                                    const isIndi = scheme.loan_type === "individual";
                                                    return (
                                                        <div key={scheme.tab_key} className="loan-details-content">
                                                            <div className="exam-result-container table-wrapper">
                                                                <div className="d-md-flex ms-auto mb-2">
                                                                    <label className="my-auto pt-2 exam-title">
                                                                        <span className={`badge me-2 ${isIndi ? "bg-info" : "bg-primary"}`}>
                                                                            {isIndi ? "Individual Loan" : "Group Loan"}
                                                                        </span>
                                                                        <strong>{isIndi ? scheme.scheme_name : scheme.group_name}</strong>
                                                                    </label>
                                                                </div>
                                                                <div className="result-summary">
                                                                    <p><strong>Scheme:</strong> {scheme.scheme_name}</p>
                                                                    <p><strong>Interest ₹ Rs:</strong> {scheme.interest}</p>
                                                                    <p><strong>Due:</strong> {scheme.no_of_dues}</p>
                                                                    <p><strong>Total:</strong> ₹ {scheme.total_amount}</p>
                                                                    <p><strong>Status:</strong> <span className={scheme.loan_status == 2 ? "result-fail" : "result-pass"}>{scheme.loan_status == 2 ? "Rejected" : scheme.loan_status == 3 ? "Completed" : "Ongoing"}</span></p>
                                                                    <p className="text-success"><strong>Total Profit:</strong> ₹ {scheme.total_profit}</p>
                                                                </div>

                                                                {/* Loan Entries Table */}
                                                                <table className="result-table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Due No</th>
                                                                            <th>Due Date</th>
                                                                            <th>Paid Date</th>
                                                                            <th>Principle</th>
                                                                            <th>Interest</th>
                                                                            <th>Total</th>
                                                                            <th>Paid</th>
                                                                            <th>Status</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {scheme.entries.map((entry, entryIndex) => (
                                                                            <tr key={entryIndex}>
                                                                                <td>{entryIndex + 1}</td>
                                                                                <td>{entry.loan_duedate}</td>
                                                                                <td>{(entry.loanpaid != null && entry.loanpaid != '0' && entry.loanpaid != '') ? entry.loan_paiddate : ''}</td>
                                                                                <td>{entry.loan_principle}</td>
                                                                                <td>{entry.loan_interest}</td>
                                                                                <td>{entry.loan_total}</td>
                                                                                <td>{entry.loanpaid}</td>
                                                                                <td>
                                                                                    <span className={(entry.loanpaid != null && entry.loanpaid != '0' && entry.loanpaid != '') ? 'result-pass' : 'result-fail'}>
                                                                                        {(entry.loanpaid != null && entry.loanpaid != '0' && entry.loanpaid != '') ? 'Paid' : 'Pending'}
                                                                                    </span>
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                                <hr />
                                                            </div>
                                                        </div>
                                                    );
                                                }
                                                return null;
                                            })}



                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>


                </div>
            </div>
        </div>
    );
}
